import { createBrowserRouter } from "react-router-dom";
import { lazy, Suspense } from "react";
import MainRoutes from "./MainRoutes";
import GuestGuard from "./GuestGuards";
import routeConstants from "../utils/routeConstants";
import LoadingFallback from "../components/common/LoadingFallback";

const LoginWithTrialPartners = lazy(() => import("../pages/auth/login-with-trialpartners"));

const router = createBrowserRouter([
  {
    path: routeConstants.login,
    element: (
      <GuestGuard>
        <Suspense fallback={<LoadingFallback />}>
          <LoginWithTrialPartners />
        </Suspense>
      </GuestGuard>
    ),
  },
  MainRoutes,
]);

export default router;
